export default __webpack_public_path__ + "static/media/8Watchguard.bb43db5f.svg";